import React from 'react';
import NumberWrapper from 'flow/components/ui-components/NumberWrapper';
import useAppContext from 'flow/hooks/useAppContext';
import useContact from 'flow/hooks/useContact';
import { CallRecord } from 'flow/types/CallRecord';
import { TypedMap } from 'flow/types/TypedMap';
import { getCallRecordTitleTW } from 'flow/utils/call-records-utils';
import { getCountryCode } from 'flow/utils/extension-utils';

interface Props {
    callRecord: TypedMap<CallRecord>;
}

const OtherPerson = ({ callRecord }: Props) => {
    const { i18next } = useAppContext();
    const { ownContact } = useContact();

    return getCallRecordTitleTW(
        callRecord,
        i18next,
        (children: string) => <NumberWrapper>{children}</NumberWrapper>,
        getCountryCode(ownContact, null).toUpperCase(),
    );
};

export default OtherPerson;
